import React, { useState } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Tooltip from '@material-ui/core/Tooltip';

import checkIsMobile from 'utils/CheckIsMobile';

const useStyles = makeStyles((theme: Theme) => ({
	tooltip: {
		maxWidth: 160,
		color: 'white',
		backgroundColor: '#004E9C',
		marginTop: 16,
	},
	arrow: {
		color: '#004E9C',
	},
	iconTooltip: {
		cursor: 'pointer',
	},
}));

type InputTooltipProps = {
	title: string;
};

function ResponseTooltip({ title }: InputTooltipProps) {
	const classes = useStyles();

	const [open, setOpen] = useState(false);

	const handleTooltipClose = () => {
		setOpen(false);
	};

	const handleTooltipOpen = () => {
		setOpen(true);
	};

	const algunawea = () => {
		setOpen(false);
	};

	if (checkIsMobile()) {
		return (
			<ClickAwayListener onClickAway={algunawea}>
				<div>
					<Tooltip
						title={title}
						arrow
						classes={{
							tooltip: classes.tooltip,
							arrow: classes.arrow,
						}}
						PopperProps={{
							disablePortal: true,
						}}
						onClose={handleTooltipClose}
						open={open}
						disableFocusListener
						disableHoverListener
						disableTouchListener
					>
						<InfoOutlinedIcon onClick={handleTooltipOpen} className="referencia-tooltip" />
					</Tooltip>
				</div>
			</ClickAwayListener>
		);
	} else {
		return (
			<Tooltip
				title={title}
				arrow
				placement="top"
				classes={{
					tooltip: classes.tooltip,
					arrow: classes.arrow,
				}}
			>
				<InfoOutlinedIcon className="referencia-tooltip" />
			</Tooltip>
		);
	}
}
export default ResponseTooltip;
